import { useIntl } from 'react-intl';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDirtyFormBlocker } from '@/features/form';

/**
 * If you pass in a navigation callback it is your responsibility to call or not call navigate()
 */
export type NavigationCallback = (navigate: () => void) => Promise<void> | void;

export type UnsavedChangesBlockerDialogProps = {
    isDirty: boolean;
    /**
     * Since react-router v7 uses transitions for location changes, isDirty will be true when the transition starts, but
     * we can use isBusy to ignore the dirty flag while we are saving data.
     */
    isBusy?: boolean;
};

export function UnsavedChangesBlockerDialog(
    props: UnsavedChangesBlockerDialogProps,
) {
    const blocker = useDirtyFormBlocker(props.isDirty && !props.isBusy);
    const [open, setOpen] = useState(blocker.state === 'blocked');
    const { formatMessage } = useIntl();

    // If we dont do this, there will be occational flashes of the dialog when not really needed
    useEffect(() => {
        setOpen(blocker.state === 'blocked');
    }, [blocker.state]);
    return (
        <Dialog open={open && blocker.state === 'blocked'}>
            <DialogTitle>
                {formatMessage({
                    defaultMessage: 'You have unsaved changes',
                    description: 'Unsaved changes dialog - Title',
                })}
            </DialogTitle>
            <DialogContent dividers>
                {formatMessage({
                    defaultMessage:
                        'If you leave this form now, you will loose your changes. ',
                    description: 'Unsaved changes dialog - Description',
                })}
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={blocker.state === 'proceeding'}
                    onClick={() => blocker.proceed()}
                >
                    {formatMessage({
                        defaultMessage: 'Leave form',
                        description:
                            'Unsaved changes dialog - Button to ignore changes',
                    })}
                </Button>
                <Button
                    disabled={blocker.state === 'proceeding'}
                    onClick={() => blocker.reset()}
                >
                    {formatMessage({
                        defaultMessage: 'Keep editing',
                        description:
                            'Unsaved changes dialog - Button to stay on page',
                    })}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
